import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {

  constructor(private http:HttpClient,private global:Global) { }
  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };
  getOrganisaitonData(){
    return this.http.get(this.global._Url +"/_api/web/lists/GetByTitle('Organisation')/items?"
      +"$select=*,AttachmentFiles&$expand=AttachmentFiles&$top=1000",this.httpOptions);
  }
}
